import { createContext } from 'react';

export { BaseToast } from './BaseToast';
export * from './types';

export default createContext({}).Provider;
